var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-password-page"},[_c('ElementBrand'),_c('TheLogin',[_c('TheLoginNewPassword',{attrs:{"token":_vm.token,"firstTime":_vm.firstTime,"userEmail":_vm.email}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }